import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Progress, Tooltip } from 'antd';
import { orderBy } from 'lodash';
//fontawesome
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import {
  convertISOToDateFormat,
  convertISOToDateTimeFormat
} from '../../../../../util/timezone';
import { normalizeAlertScore } from '../../../../../util/normalization';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../../constants/globalConstants';

import styles from './index.scss';
import AdditionalInformationModal from './AdditionalInformationModal';

export const NSAlertDetailTopPannel = ({
  GS,
  navigateTo,
  data,
  isEmbedded,
  alertMetaPrefix,
  alertMetaSuffix
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const getAlertViewTopPanel = (GS) => {
    let renderData = [];
    let colNames = [
      'alertId',
      'alertDate',
      'alertScore',
      'alertLevel',
      'transactionKey',
      'txnDateTime'
    ];
    if (alertMetaPrefix) renderData = [alertMetaPrefix];
    const sortedSettings = orderBy(
      GS.widgetConfig,
      ['columnIndex'],
      ['asc']
    ).filter((column) => column.columnVisibility);
    renderData.push(
      ...sortedSettings.map((setting, key) => {
        return (
          <div className={styles.list} key={key}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => {
                if (column.itemName === 'alertScore')
                  return (
                    <div className={styles.list_container} key={idx}>
                      <div className={styles.list_head}>Score</div>
                      <div className={styles.list_content}>
                        <Progress
                          percent={data.alertScore}
                          strokeColor={data.alertLevelColor}
                          showInfo={false}
                        />
                        <Tooltip title={normalizeAlertScore(data?.alertScore)}>
                          <p>
                            <b>
                              {normalizeAlertScore(
                                data?.alertScore?.toFixed(2).toString()
                              )}
                            </b>
                            /100
                          </p>
                        </Tooltip>
                      </div>
                    </div>
                  );
                else if (column.itemName === 'additionalInfo')
                  return (
                    <div className={styles.list_container} key={idx}>
                      <div className={styles.list_head}>{column.itemLabel}</div>
                      <div className={styles.list_content}>
                        {data[column.itemName] ? (
                          <button
                            onClick={() => setIsModalOpen(true)}
                            style={{ color: '#0052CC' }}>
                            See More..
                          </button>
                        ) : (
                          '--'
                        )}
                        <AdditionalInformationModal
                          isModalOpen={isModalOpen}
                          setIsModalOpen={setIsModalOpen}
                          data={data.additionalInfo}
                        />
                      </div>
                    </div>
                  );
                else
                  return (
                    <div className={styles.list_container} key={idx}>
                      <div className={styles.list_head}>{column.itemLabel}</div>
                      <div className={styles.list_content}>
                        <Tooltip
                          title={
                            column.itemName == 'alertDate' ||
                            column.itemName == 'txnDateTime'
                              ? convertISOToDateTimeFormat(
                                  data[column.itemName]
                                )
                              : data[column.itemName]
                          }>
                          <StyledParagraph
                            $ellipsis={!colNames?.includes(column.itemName)}>
                            <b>
                              {data[column.itemName]
                                ? column.itemName == 'alertDate' ||
                                  column.itemName == 'txnDateTime'
                                  ? convertISOToDateFormat(
                                      data[column.itemName]
                                    )
                                  : String(data[column.itemName]).length > 30
                                  ? String(data[column.itemName]).substring(
                                      0,
                                      20
                                    )
                                  : data[column.itemName]
                                : '--'}
                            </b>
                          </StyledParagraph>
                        </Tooltip>
                      </div>
                    </div>
                  );
              })}
          </div>
        );
      })
    );

    if (alertMetaSuffix) renderData.push(alertMetaSuffix);

    return renderData;
  };

  if (GS?.isVisible)
    return (
      <div className={styles.wrapper}>
        <div className={styles.head} id="alertDetail-head">
          <div className={styles.alignCenter}>
            {isEmbedded !== true && (
              <React.Fragment>
                <div
                  id="back_ArrowBtn"
                  onClick={() =>
                    navigateTo(
                      `${ROUTE_AMLS_SMART_SCREENING}/runInstance?tab=2`
                    )
                  }
                  style={{ cursor: 'pointer' }}>
                  <FontAwesomeIcon icon={faArrowLeft} color={'#000'} />
                </div>
                <h4>{GS.widgetName}</h4>
              </React.Fragment>
            )}
          </div>
        </div>
        <div className={styles.head_content}>{getAlertViewTopPanel(GS)}</div>
      </div>
    );
  else return null;
};

const StyledParagraph = styled.p`
  ${({ $ellipsis }) =>
    $ellipsis &&
    `
    display: inline-block;
    width: 40px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      overflow: visible;
      white-space: normal;
    }
  `}
`;

NSAlertDetailTopPannel.propTypes = {
  GS: PropTypes.object,
  navigateTo: PropTypes.func.isRequired,
  data: PropTypes.object,
  isEmbedded: PropTypes.bool,
  alertMetaPrefix: PropTypes.element,
  alertMetaSuffix: PropTypes.element
};

export default NSAlertDetailTopPannel;
